import React from "react";
import "./App.css";
import { CoreApp } from "./components";

function App() {
  return (
    <React.Suspense>
      <CoreApp />
    </React.Suspense>
  );
}

export default App;
